import { iaTheme } from 'ia-react-core';
import { AppTheme } from '../interfaces/Theme';
import { ReactComponent as LogoFr } from './images/iAGF.svg';
import { ReactComponent as LogoEn } from './images/iAFG.svg';

const appTheme: AppTheme = {
  ...iaTheme,
  isGBI: false,
  informativeMessageIconColor: '#3f92a6',
  assets: {
    ...iaTheme.assets,
    logoFr: LogoFr,
    logoEn: LogoEn,
    horizontalLogoFr: LogoFr,
    horizontalLogoEn: LogoEn,
    horizontalLogoInvFr: LogoFr,
    horizontalLogoInvEn: LogoEn,
  },

  MainLogo: {
    ...iaTheme.MainLogo,
    width: '92px',
    height: '50px',
    lgWidth: '92px',
    lgHeight: '50px',
  },

  layout: {
    ...iaTheme.layout,
    maxContentWidth: 100000,
    maxHeaderContentWidth: 1000000,
    maxFooterContentWidth: 1000000,
    footerBackground: iaTheme.colors.white,
    headerPadding: '8px 16px',
    lgHeaderPadding: '16px 32px',
    footerPadding: '48px 16px',
    lgFooterPadding: '48px 32px',
    noFooterLanguageButton: false,
  },
  Modal: {
    ...iaTheme.Modal,
    background: '#fff',
    closeButtonBackground: 'transparent',
    closeButtonHoverBackground: 'transparent',
    closeButtonActiveBackground: 'transparent',
  },
};

export default appTheme;
